'use client';

import { useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { IconXboxXFilled } from '@tabler/icons-react';
import { Badge, Center, Pagination, Text } from '@mantine/core';
import { useOutletStore } from '@/src/stores/OutletStore';
import { useGlobalSearchStore } from '../../stores/use-global-search-store';
import { Produk } from './Produk';

export function TabProduk() {
  const outletId = useOutletStore().dataOutlet?.branch_point_id ?? 0;
  const [activePage, setPage] = useState(1);
  const [totalItem, setTotalItem] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const params = {
    type: searchParams.get('type'),
    search: searchParams.get('search'),
  };
  const resetSearch = useGlobalSearchStore((state) => state.resetState);
  const totalPage = Math.ceil(totalItem / perPage);

  const handleTotalData = (total: number, per_page: number) => {
    setTotalItem(total);
    setPerPage(per_page);
  };

  const handleCancelSearch = () => {
    resetSearch();
    router.push(pathname);
  };

  return (
    <>
      {params.search && (
        <Badge
          variant="light"
          color="brand"
          size="lg"
          mt="lg"
          rightSection={
            <IconXboxXFilled
              size={18}
              onClick={handleCancelSearch}
              className="cursor-pointer"
            />
          }
        >
          {params.search}
        </Badge>
      )}
      <Text ta="right" mb={15}>
        {totalItem} Produk
      </Text>
      <Produk
        outlet_id={outletId}
        offset={activePage}
        size={20}
        totalData={handleTotalData}
        search={params.search!}
      />
      {totalPage > 1 && (
        <Center mt="lg">
          <Pagination total={totalPage} value={activePage} onChange={setPage} />
        </Center>
      )}
    </>
  );
}
